import DOMPurify from 'dompurify';
import React from 'react';
import { NavLink } from 'react-router-dom';

export const makeBold = (text, keywords) => {
  const regex = new RegExp(`(${keywords.join('|')})`, 'gi');
  return text.split(regex).map((part, i) => (
    keywords.some(word => part.toLowerCase() === word.toLowerCase())
      ? <strong key={i}>{part}</strong>
      : part
  ));
};

export const formatDateNumberInText = (date) => {
  // Convertir la chaîne de caractères en objet Date
  const dateObj = new Date(date);

  // Options de formatage
  const options = { day: '2-digit', month: 'long', year: '2-digit' };

  // Convertir la date au format souhaité
  const formattedDate = dateObj.toLocaleDateString('fr-FR', options);

  return formattedDate; // Affichera : 01 novembre
}

// Fonction pour ajouter des balises span avec une classe spécifique aux mots ou expressions donnés
export const addClass = (text, keywords, className) => {
  let textWithClass = text;
  keywords.forEach(keyword => {
    const regex = new RegExp(keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "g"); // Échapper les caractères spéciaux
    textWithClass = textWithClass.replace(regex, `<span class="${className}">${keyword}</span>`);
  });
  return textWithClass;
};

// Fonction pour convertir les retour à la lignes
export const nl2br = (str, is_xhtml) => {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

// Fonction pour assainir du code html
export const safeHtml = (html) => {
  return {
    __html: DOMPurify.sanitize(html)
  };
};

// Fonction permettant de vérifier si un lien appartient au domaine de ce site ou si externe
export const isExternalLink = (url) => {
  const domain = window.location.hostname; // Domaine actuel
  try {
    const linkDomain = new URL(url).hostname; // Domaine du lien
    return domain !== linkDomain; // Retourne true si le lien est externe
  } catch (err) {
    return false
  }
};

export const processHTML = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const elements = Array.from(doc.body.childNodes);

  const transformNode = (node, key) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.tagName === 'A') {
        const originalHref = node.getAttribute('href');
        const absoluteHref = originalHref.startsWith('/')
          ? originalHref
          : `/${originalHref}`;

        return (
          <NavLink key={key} to={absoluteHref}>
            {Array.from(node.childNodes).map((child, index) =>
              transformNode(child, `${key}-${index}`)
            )}
          </NavLink>
        );
      }

      const props = {};
      Array.from(node.attributes).forEach((attr) => {
        props[attr.name] = attr.value;
      });

      return React.createElement(
        node.tagName.toLowerCase(),
        { key, ...props },
        ...Array.from(node.childNodes).map((child, index) =>
          transformNode(child, `${key}-${index}`)
        )
      );
    } else if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent;
    }
    return null;
  };

  return elements.map((element, index) => transformNode(element, index));
};

